import { BeautyProfileCreate } from 'components/general-settings/beauty-profile-create/BeautyProfileCreate'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { Alert } from 'avo-ui'
import { API_BEAUTY_PROFILE } from 'services/apiBeautyProfile'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import {
    GET_ITEM_FIELD_NAME,
    INITIAL_STATE,
    FIELD_NAME_DETAIL,
    GET_FIELD_NAME,
} from 'configs/general-settings/configFormBeautyProfile'

export const BeautyProfileCreateContainer = () => {
    const navigate = useNavigate()
    const [beautyProfileDetail, setBeautyProfileDetail] = useState({})
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [searchParams] = useSearchParams()
    const beautyProfileId = searchParams.get('beautyProfileId')
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getBeautyProfileDetail, isLoading } = useFetch(API_BEAUTY_PROFILE.DETAIL)
    const { fetching: getUrlBeautyProfileImages } = useFetch(API_BEAUTY_PROFILE.URL_BEAUTY_PROFILE_IMAGES)
    const { fetching: createBeautyProfile, isLoading: isCreating } = useFetch(API_BEAUTY_PROFILE.CREATE)
    const { fetching: updateBeautyProfile, isLoading: isUpdating } = useFetch(API_BEAUTY_PROFILE.UPDATE)

    const onChangeForm = (item) => {
        setBeautyProfileDetail({ ...beautyProfileDetail, ...item })
    }

    const setShowAlert = (message) => {
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const setUploadIconImages = async (filesName, uploadDetail) => {
        const newBeautyProfileItems = [...beautyProfileDetail?.items]

        try {
            const s3Urls = await getUrlBeautyProfileImages({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newBeautyProfileItems[uploadDetail[i]?.index] = {
                    ...newBeautyProfileItems[uploadDetail[i]?.index],
                    image_url: `${item?.url}${item?.fields?.key}`,
                }
            })
            await Promise.all(apiS3list)
            const newDetail = {
                ...beautyProfileDetail,
                items: newBeautyProfileItems,
            }
            onSave(newDetail)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateItems = () => {
            const result = []
            beautyProfileDetail?.items?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(beautyProfileDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && (!beautyProfileDetail[key] || beautyProfileDetail[key]?.length === 0)) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'items' && validateItems()?.length) {
                    errors['items_detail'] = validateItems()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const iconImages = beautyProfileDetail?.items?.map((item) => item?.image_url)
            const uploadDetail = []
            const filesName = []

            iconImages.map((item, index) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({ file: item?.file, index })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadIconImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...beautyProfileDetail }) => {
        const newPayload = {
            ...payload,
            items: payload?.items?.map((item, index) => {
                return {
                    ...item,
                    sequence: index,
                }
            }),
        }

        if (!beautyProfileId) {
            createBeautyProfile(newPayload)
                .then(() => {
                    setShowAlert('Beauty Profile Created !')
                    navigate('/general-setting/beauty-profile-list')
                })
                .catch((error) =>
                    setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL, GET_ITEM_FIELD_NAME)),
                )
        } else {
            updateBeautyProfile(newPayload, beautyProfileId)
                .then(() => {
                    setShowAlert('Beauty Profile Updated !')
                    navigate('/general-setting/beauty-profile-list')
                })
                .catch((error) =>
                    setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL, GET_ITEM_FIELD_NAME)),
                )
        }
    }

    useEffect(() => {
        if (beautyProfileId) {
            getBeautyProfileDetail({}, beautyProfileId).then((response) => {
                setBeautyProfileDetail({ ...response?.data })
            })
        } else {
            setBeautyProfileDetail({
                ...INITIAL_STATE,
                items: [
                    {
                        name: null,
                        image_url: null,
                    },
                ],
            })
        }
        setErrorForm({})
    }, [beautyProfileId])

    const props = {
        sectionProps: {
            beautyProfileDetail,
            onChangeForm,
            errorForm,
        },
        isLoadingUpload,
        isLoading,
        isCreating,
        isUpdating,
        onSubmit,
    }

    return <BeautyProfileCreate {...props} />
}
